import { render, staticRenderFns } from "./PopUpDelete.vue?vue&type=template&id=828f2910&scoped=true"
import script from "./PopUpDelete.vue?vue&type=script&lang=js"
export * from "./PopUpDelete.vue?vue&type=script&lang=js"
import style0 from "./PopUpDelete.vue?vue&type=style&index=0&id=828f2910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f2910",
  null
  
)

export default component.exports